import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    AttachmentActionDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    touchTargets,
    pointerType,
    isDisabled,
    radiuses,
    borders,
    colors
}: AttachmentActionDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: touchTargets.fine,
        touchTargets,
        pointerType
    });

    const styles = {
        surface: {
            backgroundColor: isDisabled ? colors.system.state.overlay.disabled.neutral : "transparent",
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            }),
            height: touchTargets.fine,
            width: touchTargets.fine
        } as Mutable<ViewStyle>,
        container: {
            minHeight: hitArea.minHeight,
            minWidth: hitArea.minWidth
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
